import Vue from 'vue'
import api from './api'

export { default as i18n } from './i18n'

export default {
    load () {
        Vue.use(api)
    }
}
